import React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Box, Grid } from "@material-ui/core";
import SecondaryButton from "./SecondaryButton";
import { Link } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        grow: {
            flexGrow: 1,
        },
        boxLine: {
            border: '1px solid #ebdcc6',
            borderRadius: '4px',
            boxShadow: 'none',
            padding: 10,
            backgroundColor: '#ffffff'
        },
        boxTitle: {
            paddingBottom: 10,
            paddingTop: 10,
            fontWeight: 'bold',
            fontSize: '18px'
        },
        largeTitle: {
            paddingBottom: 15,
            fontWeight: 'bold',
            fontSize: '25px'
        },
        text: {
            fontSize: '16px',
            lineHeight: '25px'
        }
    }),
);

const About: React.FC = () => {
    const classes = useStyles();
    const intl = useIntl();

    return (
        <Box pt={2} pb={1} pl={6} pr={6}>
            <Box className={classes.largeTitle} textAlign="center">
                <FormattedMessage id="nav.about" />
            </Box>
            <Grid container justify="center" spacing={4} alignContent="center">
                <Grid item xs={12} sm={6}>
                    <img src="/images/about/about-1.png" alt="" width="100%" />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <span className={classes.text}>
                        <b><FormattedMessage id="about.companyTitle" /></b><br />
                        <FormattedMessage id="about.text1" />
                        <br />
                        <FormattedMessage id="about.text2" />
                    </span>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <span className={classes.text}>
                        <FormattedMessage id="about.text3" />
                        <br />
                        <FormattedMessage id="about.text4" />
                    </span>
                    <Box pt={3} pb={3} alignContent="center">
                    <Link to="/contacts"><SecondaryButton labelText={intl.formatMessage({ id: "about.contactUs" })} buttonEnabled={true} /></Link>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <img src="/images/about/about-2.png" alt="" width="100%" />
                </Grid>
            </Grid>
        </Box>
    );
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {};
};

export default connect(mapDispatchToProps)(About);
